import { action, observable } from "mobx";
import FetchBase from "../Api/FetchBase";
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import { API_ENDPOINTS } from "../Utils/constants";
import { getAllJobResourceIdAndDate } from "../Utils/jobHelper";

const setWeekDates = (weekDate) => {
	const startDate = moment(weekDate);
	const endDate = moment(weekDate).add(1, 'w');
	let data = [];
	for (let m = startDate; m.isBefore(endDate); m.add(1, 'days')) {
		data = [...data, m.format('YYYY-MM-DD')];
	}
	return data;
};
export default class JobBoardStore extends FetchBase {
	@observable quater = moment('2022-03-01').startOf('quarter');
	@observable week = moment('2022-03-01').startOf('week');
	@observable weekDates = setWeekDates(moment('2022-03-01').startOf('week'));
	@observable categories = [];
	@observable filter = '';
	@observable jobs = [];
	@observable projects = [];
	@observable showNotification = '';
	@observable selectedJob = null;
	@observable copiedJobsData = [];
	@observable leadList = [];
	@observable categoryFilters = [];
	@observable filterData = {
		superCat: [],
		cat: [],
		subCat: []
	};
	@observable openKeysFromStore = [];
	@observable selectedAllCat = true;
	@observable slectedJobData = null;

	@action.bound
	setSelectedJobResourceAndDate = (data) => {
		console.log('data setSelectedJobResourceAndDate', data);
		this.slectedJobData = data;
	};

	@action.bound
	onQuaterChange = (date) => {
		this.quater = date;
		this.week = moment(date).add(1, 'w').startOf('week');
	};

	@action.bound
	onWeekChange = (date) => {
		this.week = moment(date).startOf('week');
		this.weekDates = setWeekDates(moment(date).startOf('week'));
	};

	@action.bound
	onNextWeek = () => {
		const newWeek = moment(this.week).add(1, 'w');
		this.week = newWeek;
		this.weekDates = setWeekDates(newWeek);
	};

	@action.bound
	onPrevWeek = () => {
		const prevWeek = moment(this.week).add(-1, 'w');
		this.week = prevWeek;
		this.weekDates = setWeekDates(prevWeek);
	};

	@action.bound
	setCategories = (data) => {
		this.openKeysFromStore = [];
		this.categories = data;
		const supCatId = data[0]?.id.toString();
		const defaultKey = [supCatId,
			data[0]?.categories[data[0]?.categories.length - 1]?.id.toString()];
		const supCatFilerExist = this.categoryFilters?.filter((cat) => cat.catType === 'supCat');
		const catFilerExist = this.categoryFilters?.filter((cat) => cat.catType === 'cat');
		const subCatFilerExist = this.categoryFilters?.filter((cat) => cat.catType === 'subCat');
		let openKeyData = [];
		if (supCatFilerExist.length > 0 && catFilerExist.length > 0 && subCatFilerExist.length > 0) {
			openKeyData = [
				...supCatFilerExist.map(cat => cat.catId.toString()),
				...catFilerExist.map(cat => cat.catId.toString())];
		} else {
			openKeyData = defaultKey;
		}
		this.openKeysFromStore = openKeyData;
	};

	@action.bound
	setFilter = (e) => this.filter = e.target.value;

	@action.bound
	setJobs = (data) => this.jobs = data;

	@action.bound
	getAllProjects = async () => {
		try {
			let options = {};
			options['isDraft'] = false;
			options['isDeleted'] = false;
			options['pageNo'] = 0;
			options['pageLimit'] = 0;
			options['projectStatusId'] = [1, 2];
			let response = await this.post(API_ENDPOINTS.GET_ALL_PROJECTS, options);

			if (response.status) {
				if (response.data?.projects?.length) {
					let data = [];
					response.data.projects.forEach(project => {
						data = [...data, {
							label: project.name,
							value: project.id,
							customer: project.customer
						}];
					});
					this.projects = data;
				}
				return true;
			}
		} catch (err) {
			return false;
		}
	};

	@action.bound
	setNotification = (status) => this.showNotification = status;

	@action.bound
	setSelectedJobData = (data) => this.selectedJob = data;

	@action.bound
	setCopiedJobsData = (jobData) => {
		if (jobData.length === 0) {
			this.copiedJobsData = [];
		} else {
			const index = this.copiedJobsData.findIndex((copyJob) =>
				copyJob.jobDate === jobData.jobDate && copyJob.resourceId === jobData.resourceId);
			let data = [];
			if (index > -1) {
				this.copiedJobsData.splice(index, 1);
				data = this.copiedJobsData;
			} else {
				data = [...this.copiedJobsData, jobData];
			}
			this.copiedJobsData = cloneDeep(data);
		}
	};

	@action.bound
	setAllJobs = () => {
		const jobIds = cloneDeep(getAllJobResourceIdAndDate(
			cloneDeep(this.jobs),
			this.weekDates,
		));
		const newData = jobIds.filter(
			(jobdata) => {
				return !(jobdata.resourceId === this.slectedJobData.resourceId &&
					moment(jobdata.jobDate).isSame(this.slectedJobData.jobDate));
			}
		);
		this.copiedJobsData = newData;
	};

	@action.bound
	setMovedJobsData = (jobData) => {
		if (jobData.length === 0) {
			this.copiedJobsData = [];
		} else {
			this.copiedJobsData = [jobData];
		}
	};

	@action.bound
	getAllLeads = async (projectId) => {
		try {
			let options = {};
			options['projectId'] = projectId;
			options['customerUser'] = false;
			options['pageLimit'] = 100;
			let response = await this.post(API_ENDPOINTS.GET_TEAM, options);

			if (response.status) {
				let data = [];
				if (response.data?.users?.length) {
					response.data.users.forEach(user => {
						data = [...data, {
							name: user.fullName,
							id: user.id,
							isOnSiteLead: user.isOnSiteLead
						}];
					});
				}
				this.leadList = data;
				return true;
			}
		} catch (err) {
			return false;
		}
	};

	@action.bound
	setCategoryFilters = (catId, catType, parentCatId) => {
		const newFilterData = cloneDeep(this.filterData);
		const findIndex = this.categoryFilters.findIndex(selectdCat => selectdCat.catId === catId);

		const parentIsInList = this.categoryFilters.filter(cat => cat.catId === parentCatId);
		const superParentIsInList = this.categoryFilters.filter(cat =>
			parentIsInList.some(childCat => cat.catId === childCat.parentCatId));
		const childIsInList = this.categoryFilters.filter(cat => cat.parentCatId === catId);
		const subChildIsInList = this.categoryFilters.filter(cat =>
			childIsInList.some(childCat => cat.parentCatId === childCat.catId));
		let data = null;
		// reselection of cat 
		if (findIndex > -1) {
			if (parentIsInList.length > 0 && childIsInList.length > 0) { //parent & child cat alredy selected
				data = {
					superCat: [...newFilterData.superCat, ...childIsInList.map(cat => cat.catId)],
					cat: [...newFilterData.cat.filter(id => id !== catId)],
					subCat: [...newFilterData.subCat.filter((catFiler) =>
						!childIsInList.some(obj => obj.catId === catFiler)
					)]
				};
			} else if (parentIsInList.length > 0) { //parent cat alredy selected
				data = {
					superCat: [...newFilterData.superCat],
					cat: superParentIsInList.length > 0
						? [...newFilterData.cat] : [...newFilterData.cat.filter(id => id !== catId)],
					subCat: superParentIsInList.length > 0
						? newFilterData.subCat.filter(id => id !== catId) : [...newFilterData.subCat]
				};
			} else if (childIsInList.length > 0) { //child cat alredy selected
				data = {
					superCat: [...newFilterData.superCat.filter(id => id !== catId),
					...childIsInList.map(cat => cat.catId)],
					cat: subChildIsInList.length > 0
						? [...newFilterData.cat.filter((catFiler) =>
							!childIsInList.some(obj => obj.catId === catFiler)
						), ...subChildIsInList.map(cat => cat.catId)]
						: [...newFilterData.cat.filter((catFiler) =>
							!childIsInList.some(obj => obj.catId === catFiler)
						)],
					subCat: subChildIsInList.length > 0
						? [...newFilterData.subCat.filter((catFiler) =>
							!subChildIsInList.some(obj => obj.catId === catFiler)
						)] : newFilterData.subCat
				};
			} else {
				data = {
					superCat: newFilterData.superCat.filter(id => id !== catId),
					cat: newFilterData.cat.filter(id => id !== catId),
					subCat: newFilterData.subCat.filter(id => id !== catId)
				};
			}
			this.filterData = data;
			const newCatFilter = this.categoryFilters.filter(selectdCat => selectdCat.catId !== catId);
			this.categoryFilters = newCatFilter;
		} else { // selectin of cat
			let childCatsOfSelectedCat = [];
			let subChildCatsOfSelectedCat = [];
			let childCategoryFilters = [];
			let subChildCategoryFilters = [];
			if (catType === 'supCat') {
				for (let index = 0; index < this.categories.length; index++) {
					const supCat = this.categories[index];
					if (supCat.id === catId) {
						for (let cindex = 0; cindex < supCat?.categories.length; cindex++) {
							const cat = supCat?.categories[cindex];
							childCatsOfSelectedCat = [...childCatsOfSelectedCat, cat.id];
							childCategoryFilters = [...childCategoryFilters, {
								catId: cat.id,
								catType: 'cat',
								parentCatId: catId
							}];
							for (let sindex = 0; sindex < cat?.categories.length; sindex++) {
								const subCat = cat?.categories[sindex];
								subChildCatsOfSelectedCat = [...subChildCatsOfSelectedCat, subCat.id];
								subChildCategoryFilters = [...subChildCategoryFilters, {
									catId: subCat.id,
									catType: 'subCat',
									parentCatId: cat.id
								}];
							}
						}
					}
				}
			}
			if (catType === 'cat') {
				for (let index = 0; index < this.categories.length; index++) {
					const supCat = this.categories[index];
					for (let index = 0; index < supCat?.categories.length; index++) {
						const cat = supCat?.categories[index];
						if (cat.id === catId) {
							for (let findex = 0; findex < cat?.categories.length; findex++) {
								const subCat = cat?.categories[findex];
								childCatsOfSelectedCat = [...childCatsOfSelectedCat, subCat.id];
								childCategoryFilters = [...childCategoryFilters, {
									catId: subCat.id,
									catType: 'subCat',
									parentCatId: catId
								}];
							}
						}
					}
				}
			};

			if (childIsInList.length > 0) { // child cat alredy selected
				const otherSupCats = newFilterData.superCat.filter((supCatFiler) =>
					!childIsInList.some(obj => obj.catId === supCatFiler)
				);
				data = {
					superCat: [...otherSupCats, catId],
					cat: subChildIsInList.length > 0 ?
						[...newFilterData.cat.filter(catFiler =>
							!subChildIsInList.some(obj => obj.catId === catFiler)),
						...childCatsOfSelectedCat]
						: [...newFilterData.cat, ...childCatsOfSelectedCat],
					subCat: [...newFilterData.subCat, ...subChildCatsOfSelectedCat]

				};
			} else {
				data = {
					superCat: newFilterData.superCat.length > 0 ? [...newFilterData.superCat, catId] : [catId],
					cat: [...newFilterData.cat, ...childCatsOfSelectedCat],
					subCat: [...newFilterData.subCat, ...subChildCatsOfSelectedCat]
				};
			}
			this.filterData = data;
			const finalCategoryFilters = [...this.categoryFilters,
			{ catId, catType, parentCatId },
			...childCategoryFilters,
			...subChildCategoryFilters
			];
			this.categoryFilters = finalCategoryFilters;
			const openKeysCategories = finalCategoryFilters.filter(cat => (cat.catType === 'supCat' || cat.catType === 'cat'));
			this.openKeysFromStore = [...openKeysCategories.map(cat => {
				return cat.catId.toString();
			})];
		}
	};
	@action.bound
	setSelectAllCat = (check = false) => {
		this.selectedAllCat = check;
	};
	@action.bound
	selectAllCategories = (checked) => {
		if (checked) {
			let supCatIndex = [];
			let catIndex = [];
			let subCatIndex = [];
			let finalCategoryFilters = [];
			for (let index = 0; index < this.categories.length; index++) {
				const supCat = this.categories[index];
				supCatIndex = [...supCatIndex, supCat.id];
				finalCategoryFilters = [...finalCategoryFilters, {
					catId: supCat.id,
					catType: 'supCat',
					parentCatId: null
				}];
				for (let cindex = 0; cindex < supCat?.categories.length; cindex++) {
					const cat = supCat?.categories[cindex];
					catIndex = [...catIndex, cat.id];
					finalCategoryFilters = [...finalCategoryFilters, {
						catId: cat.id,
						catType: 'cat',
						parentCatId: supCat.id
					}];
					for (let sindex = 0; sindex < cat?.categories.length; sindex++) {
						const subCat = cat?.categories[sindex];
						subCatIndex = [...subCatIndex, subCat.id];
						finalCategoryFilters = [...finalCategoryFilters, {
							catId: subCat.id,
							catType: 'subCat',
							parentCatId: cat.id
						}];
					}
				}
			}
			const data = {
				superCat: supCatIndex,
				cat: catIndex,
				subCat: subCatIndex
			};
			this.filterData = data;
			this.categoryFilters = finalCategoryFilters;
		} else {
			const data = {
				superCat: [],
				cat: [],
				subCat: []
			};
			this.filterData = data;
			this.categoryFilters = [];
		};
	};

}